import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=f84c2d78&scoped=true&"
import script from "./Drawer.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Drawer.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=f84c2d78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c2d78",
  null
  
)

export default component.exports